import React, { Component, Fragment } from 'react'
import './Confirm.css'
import axios from 'axios'
import error from '../../assets/images/404.png'
import jsPDF from "jspdf"
import { format } from "date-fns"
import membrete from '../../assets/images/membrete.png'
import cargando from '../../assets/images/cargando.gif'

import {
  MDBRow,
  MDBCol
} from "mdbreact"

let token
let carnet
let url = 'https://admisiones.ufg.edu.sv/reingresoapis/api/v1/'
//let url = 'http://localhost:4003/api/v1/'
let reingreso

class Confirm extends Component {

  state = {
    response: {}
  }

  componentDidMount() {
    var sPaginaURL = window.location.search.substring(1)
    var sURLVariables = sPaginaURL.split('&')
    token = sURLVariables[1]
    carnet = sURLVariables[2]

    if (token !== undefined && carnet !== undefined) {
      var inicio = document.getElementById("inicio")
      inicio.style.display = "block"
    }

    // var confirm = document.getElementById("confirm");
    // confirm.style.display = "block";

  }

  mostrarConfirm = () => {
    var sPaginaURL = window.location.search.substring(1)
    var sURLVariables = sPaginaURL.split('&')
    token = sURLVariables[1]
    carnet = sURLVariables[2]

    var inicio = document.getElementById("inicio")
    inicio.style.display = "none"

    var cargando = document.getElementById("cargando")
    cargando.style.display = "block"

    if (token !== undefined && carnet !== undefined) {

      var data = {
        Token: token.toUpperCase(),
        Carnet: carnet.toUpperCase()
      }

      axios({
        url: url + 'confimReingreso',
        method: 'post',
        data: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => {
        if (response.data.Code === 200 || response.data.Code === 202 || response.data.Code === 203) {
          reingreso = response.data.Reingreso

          this.setState({
            response: response.data
          })
          cargando.style.display = "none"
          var confirm = document.getElementById("confirm")
          confirm.style.display = "block"
        }
        return response.data
      }).catch(err => {
        cargando.style.display = "none"
        var error = document.getElementById("error")
        error.style.display = "block"
        return err
      })
    }
  }

  generarPdf = () => {
    var fecha = format(new Date(), "dd/MM/yyyy")
    var hora = format(new Date(), "hh:mm:ss a")
    var doc = new jsPDF()

    var logo = new Image()
    logo.src = membrete
    doc.addImage(logo, 'JPEG', 0, 0, 210, 39)

    doc.setFont('helvetica')
    doc.setFontType('bold')
    doc.setFontSize(10)
    doc.setTextColor(0, 98, 164)
    doc.text(85, 41, 'REGISTRO ACADÉMICO')
    doc.text(73, 48, 'ACCIÓN ACADÉMICA DE REINGRESO')
    doc.setTextColor(0, 0, 0)
    doc.text(15, 48, fecha)
    doc.text(175, 48, hora)
    doc.setDrawColor(239, 137, 3)
    doc.line(15, 54, 195, 54)
    doc.setFontType('bold')
    doc.text(15, 62, 'Carnet:')
    doc.setFontType('"normal')
    doc.text(30, 62, this.state.response.Carnet)
    doc.setFontType('bold')
    doc.text(74, 62, 'Nombre:')
    doc.setFontType('normal')
    doc.text(91, 62, this.state.response.Nombre)
    doc.setFontType('bold')
    doc.text(15, 72, 'Facultad:')
    doc.setFontType('normal')
    doc.text(33, 72, this.state.response.Facultad)
    doc.setFontType('bold')
    doc.text(15, 82, 'Carrera a reingresar:')
    doc.setFontType('normal')
    doc.text(53, 82, this.state.response.NombreCarrera)
    doc.setFontType('bold')
    doc.text(15, 92, 'Plan a reingresar:')
    doc.setFontType('normal')
    doc.text(48, 92, this.state.response.PlanEstudio)
    doc.setFontType('bold')
    doc.text(74, 92, 'Ciclo de reingreso:')
    doc.setFontType('normal')
    doc.text(109, 92, this.state.response.Ciclo)
    doc.setFontType('bold')
    if (this.state.response.Mensualidad != undefined || this.state.response.Matricula != undefined) {
      doc.text(15, 102, 'Información de perfil:')
      doc.setFontType('normal')
      doc.text(53, 102, 'CUOTA ACADÉMICA: ' + this.state.response.Mensualidad + '   MATRÍCULA: ' + this.state.response.Matricula)
    }
    doc.line(15, 108, 195, 108)
    doc.setFontType('bold')
    doc.setFontSize(8)
    doc.text(15, 115, '*Puede incurrir en costos adicionales de laboratorio/')
    doc.text(15, 120, 'práctica/ taller, seguro de vida (estudiantes de turismo),')
    doc.text(15, 125, 'penalidad ACP/AVANZA según corresponda. La cuota')
    doc.text(15, 130, 'puede variar si realiza cambio de carrera.')
    doc.text(15, 140, '*Obtén tus credenciales llamando al 2209-2922, por Whatsapp')
    doc.text(15, 145, 'al 7682-2269 o escribiendo a: soportevirtual@ufg.edu.sv')
    doc.setDrawColor(0, 0, 0)
    doc.line(140, 140, 195, 140)
    doc.text(154, 145, 'Registro Académico')
    doc.save('Comprobante.pdf')
  }

  render() {
    return (
      <div>

        <div id="inicio" className="confirm">
          <div className="modalContentInicio" size="12" sm="12" md="12" lg="12" xl="12" id="modalContentInicioSpaceTop">
            <MDBRow>
              <MDBCol size="12" sm="5" md="5" lg="5" xl="5" className="columnaIzquierda" id="columnaIzquierdaInicio">
              </MDBCol>
              <MDBCol size="12" sm="7" md="7" lg="7" xl="7" className="columnaDerecha">
                <div className="col-lg-12 textoModalInicio contenedorCenterVertical">
                  Para completar tu trámite de reingreso haz clic en el botón CONFIRMAR.
                  <center>
                    <button className="boton orangeConfirm marginTopBtn" id="signIn" onClick={this.mostrarConfirm}>CONFIRMAR</button>
                  </center>
                </div>
              </MDBCol>
            </MDBRow>
          </div>
        </div>

        <div id="cargando" className="confirm">
          <div className="modalContentInicio" id="modalContentInicioSpaceTop">
            <MDBRow>
              <MDBCol size="12" sm="12" md="12" lg="12" xl="12" className="contenedorLogin">
                <img src={cargando} className="marginTop5" />
              </MDBCol>
            </MDBRow>
          </div>
        </div>

        <div id="confirm" className="confirm">
          <div className="modalContentConfirm" id="modalContentConfirmSpaceTop">
            <MDBRow>
              <MDBCol size="12" sm="12" md="12" lg="12" xl="5" className="columnaIzquierda" id="columnaIzquierdaConfirm">
                <p className="parrafoIzquierdo contenedorCenterVertical">
                  <b className="futuraBold">Tu proceso de reingreso se ha realizado satisfactoriamente</b>, para finalizar el proceso debes realizar el pago de los aranceles, en cualquiera de nuestras formas de pago.
                </p>
              </MDBCol>
              <MDBCol size="12" sm="12" md="12" lg="12" xl="7" className="columnaDerecha" id="columnaDerechaConfirm">
                <div className="col-lg-12 contenedorCenterVertical">
                  <span className="close2" id="closeConfirm">&times;</span>
                  <h3>{this.state.response.GraduadoUfg}</h3>
                  <br />
                  <div className="container-confirmacion">
                    <div className="label">
                      <b className="futuraBold">Nombre:</b>
                    </div>
                    <div>
                      {this.state.response.Nombre}
                    </div>
                  </div>

                  <div className="container-confirmacion">
                    <div className="label">
                      <b className="futuraBold">Carrera:</b>
                    </div>
                    <div>
                      {this.state.response.NombreCarrera}
                    </div>
                  </div>

                  <div className="container-confirmacion">
                    <div className="label">
                      <b className="futuraBold">Carné:</b>
                    </div>
                    <div >
                      {this.state.response.Carnet}
                    </div>

                  </div>
                  <div className="container-confirmacion">
                    <div className="label">
                      <b className="futuraBold">Ciclo:</b>
                    </div>
                    <div>
                      {this.state.response.Ciclo}
                    </div>
                  </div>
                  <div className="nota-aranceles">
                    <div className="row">
                      <div className="col-lg-12 futuraBold">
                        Aranceles que se generaran en tu inscripción.
                      </div>
                    </div>
                  </div>
                  {
                    this.state.response.Matricula != undefined ? (
                      <React.Fragment>
                        <div className="container-confirmacion">
                          <div className="label-aranceles">
                            <b className="futuraBold">Matrícula:</b>
                          </div>
                          <div>
                            US$&nbsp;{this.state.response.Matricula}
                          </div>
                        </div>

                      </React.Fragment>
                    ) : (
                      ""
                    )
                  }
                  {
                    this.state.response.Mensualidad != undefined ? (
                      <React.Fragment>
                        <div className="container-confirmacion">
                          <div className="label-aranceles">
                            <b className="futuraBold">Mensualidad:</b>
                          </div>
                          <div>
                            <span>
                              US$&nbsp;{this.state.response.Mensualidad}
                            </span>
                          </div>
                        </div>
                      </React.Fragment>
                    ) : (
                      ""
                    )
                  }


                  <br />

                  <div className="nota">
                    <div className="row">
                      <div className="col-lg-12">
                        Nota: Si realizas cambio de modalidad o de carrera, tus aranceles podrían variar.
                      </div>
                    </div>
                  </div>
                  <button className="boton orangeConfirm marginTopBtn" id="signIn" onClick={this.generarPdf}>IMPRIMIR</button>
                  <div className="footerColumnaDerecha">
                    <div className="row">
                      <div className="col-lg-12">
                        Si no recuerdas tus credenciales para ingresar a tu Web Desktop debes llamar al tel: 2209-2922 o <a href="#" className="linkCeleste">haz clic aquí</a>
                      </div>
                    </div>
                  </div>
                </div>
              </MDBCol>
            </MDBRow>
          </div>
        </div>

        <div id="error" className="confirm">
          <div className="modalContentInicio" size="12" sm="12" md="12" lg="12" xl="12" id="modalContentInicioSpaceTop">
            <MDBRow>
              <MDBCol size="12" sm="5" md="5" lg="5" xl="5" className="columnaIzquierda" id="columnaIzquierdaInicio">
                <p className="error">
                  <img src={error} width="100%"></img>
                </p>
              </MDBCol>
              <MDBCol size="12" sm="7" md="7" lg="7" xl="7" className="columnaDerecha">
                <div className="col-lg-12 textoModalInicio contenedorCenterVertical">
                  <span className="close3">&times;</span>
                  <div className="col-lg-12">
                    Lo sentimos la página a la que intentas acceder no está disponible temporalmente, intenta por favor más tarde
                  </div>
                  <div className="footercolumnaDerecha">
                    <div className="row">
                      <div className="col-lg-12">
                        Cualquier duda o consulta, no dudes en llamar al tel: 2209-2922
                      </div>
                    </div>
                  </div>
                </div>
              </MDBCol>
            </MDBRow>
          </div>
        </div>

        <div id="error" className="confirm" id="modalContentConfirmSpaceTop">
          <div className="modalContentConfirm">
            <MDBRow>
              <MDBCol size="12" lg="5" md="5" sm="5" xs="5" xl="5" className="columnaIzquierda">
                <p className="error">
                  <img src={error} width="100%"></img>
                </p>
              </MDBCol>
              <MDBCol size="12" lg="7" md="7" sm="7" xs="7" xl="7" className="columnaDerecha">
                <span className="close3">&times;</span>
                <div className="columnaDerecha">
                  <div className="col-lg-12 textoError">
                    Lo sentimos la página a la que intentas acceder no está disponible temporalmente, intenta por favor más tarde
                  </div>
                  <div className="footercolumnaDerecha">
                    <div className="row">
                      <div className="col-lg-12">
                        Cualquier duda o consulta, no dudes en llamar al tel: 2209-2922
                      </div>
                    </div>
                  </div>
                </div>
              </MDBCol>
            </MDBRow>
          </div>
        </div>

      </div>
    )
  }
}
export default Confirm